(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stisca-music"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-stisca-music]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const audio = root.querySelector('audio');
  const button = root.querySelector('button');
  let enabled = true;
  try { enabled = sessionStorage.getItem('stisca_music_disabled') !== 'true'; } catch {}
  audio.volume = 0.18;
  const update = () => {
    root.dataset.paused = String(audio.paused);
    button.setAttribute('aria-pressed', String(enabled));
    const label = enabled ? root.dataset.off : root.dataset.on;
    button.setAttribute('aria-label', label);
    button.title = label;
  };
  const start = () => {
    if (!enabled || !audio.paused) return;
    audio.play().then(update).catch(update);
  };
  button.addEventListener('click', () => {
    enabled = !enabled;
    try { sessionStorage.setItem('stisca_music_disabled', String(!enabled)); } catch {}
    if (enabled) start(); else audio.pause();
    update();
  });
  const unlock = event => {
    if (!root.contains(event.target)) start();
  };
  document.addEventListener('pointerdown', unlock, {passive:true});
  document.addEventListener('keydown', unlock);
  audio.addEventListener('play', update);
  audio.addEventListener('pause', update);
  audio.addEventListener('error', () => { root.hidden = true; });
  if (!enabled) audio.pause();
  update();
  start();
})();

  } catch(e) { console.error(e); }
})();
})();
